import {
  publicHttpClient,
  type AxiosRequestConfig,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';

export interface MealPlanResponse {
  id: string;
  period: string;
  user_id: string;
  create_at: number;
  update_at: number;
  planning_table: PlanningTable[];
  stats: Stats;
  status: string;
}

export interface PlanningTable {
  date: string;
  slot: string;
  item_name: string;
  overall_dish_tag: string;
  estimated_price: number;
  category_solo_meal: string[];
  alternatives: any[];
  planning_profile: PlanningProfile;
  image_thumb_urls: string;
  status: string;
  budget?: number;
  user_note?: string;
}

export interface PlanningProfile {
  city_id: string;
  prefer_time_slot: any;
  budget: number;
  max_price: number;
  max_distance_km: number;
  allergies: string[];
  dietary_goals: string;
  dietary_preference: string;
  name: string;
  lat: number;
  lng: number;
  user_note: string;
}

export interface Stats {
  total_slots: number;
  completed: number;
  skipped: number;
}

export const getMealPlanFn = async (
  token: string,
  config: AxiosRequestConfig = {}
): Promise<MealPlanResponse> => {
  const response = await publicHttpClient.get<MealPlanResponse>(
    apiRoutes.ahafood.store.meal_plans,
    {
      headers: { Authorization: `Bearer ${token}` },
      ...config,
    }
  );

  return response?.data;
};

export const useGetMealPlan = (
  token: string,
  opts?: Omit<UseQueryOptions<MealPlanResponse, Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<MealPlanResponse, Error>({
    queryKey: [apiRoutes.ahafood.store.meal_plans, token],
    queryFn: () => getMealPlanFn(token),
    ...opts,
  });
};
